import type { MealLogSummaryConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";

export function validate(config: MealLogSummaryConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  // A summary with no source has nothing to summarise. This also forces a new
  // pick after a cascade delete cleared the reference.
  if (!config.mealLogId || config.mealLogId.trim().length === 0) {
    errors.mealLogId = "Velg en matdagbok.";
  }
  // Optional — absent means the card is a condition table and nothing else.
  // Present but unusable has to block Save, or the energy block would render
  // dashes with no way to tell why.
  const expenditure = config.dailyEnergyExpenditure;
  if (expenditure !== undefined) {
    if (!Number.isFinite(expenditure) || expenditure <= 0) {
      errors.dailyEnergyExpenditure =
        "Energiforbruk må være et tall over 0, eller stå tomt.";
    }
  }
  // `expenditureEstimate` is deliberately not validated against
  // `dailyEnergyExpenditure` (docs/adr/0012): the field is the answer, the
  // calculator is one way of reaching it, and a partially filled calculator is
  // a legitimate intermediate state that must never block saving the widget.
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
